import { styled } from "../stitches";

const Box = styled("div", {
  outline: "none",
  margin: 0,
  minWidth: 0,
  borderRadius: "$sm",
});

export default Box;
